import { apiClientProductos } from "../../utils/apiClientProductos";
import { Product } from "../../types/product"
import { ProductFilters } from "../../types/productFilters";



export const fetchProductsPaginated = async (searchCriteria: ProductFilters): Promise<Product[]> => {
    console.log('Criterio de busqueda en productoService: ', searchCriteria);
    return  await apiClientProductos.get("/products/productsPaginated", {params: searchCriteria}).then((response) => response.data);
}

export const fetchProductsAll = async (): Promise<Product[]> => {
    return await apiClientProductos.get("/products/productsAll").then((response) => response.data);
}

export const putImageProductMetaData = async (productSku: string, productImage: any): Promise<any> => {
    console.log('Actualizando metadata del producto: ', productImage);
    return  await apiClientProductos.put(`/products/update-metadata/${productSku}`, productImage).then((response) => response.data);
}

export const deleteImageProduct = async (productSku: string, imageName: string): Promise<any> => {
    console.log(`Eliminando imagen ${imageName} del producto SKU: ${productSku}`);
    return  await apiClientProductos.delete(`/products/delete-image/${encodeURIComponent(productSku)}/${encodeURIComponent(imageName)}`, {data: { imageName }}).then((response) => response.data);
}

export const postImageProduct = async (image: any): Promise<any> => {
    console.log('Agregando a Oracle imagen al producto: ', image.Sku);
    return  await apiClientProductos.post(`/products/add-image`, image).then((response) => response.data);
}